import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UrlService {
  constructor() {}

  /**
   * Récupère le code pays depuis localStorage
   */
  getCountryCode(): string {
    if (typeof localStorage !== 'undefined') {
      const saved = localStorage.getItem('defaultCountry');
      if (saved) {
        try {
          const country = JSON.parse(saved);
          return country.code?.toLowerCase() || '';
        } catch {
          return '';
        }
      }
    }
    return ''; // Pas de pays par défaut
  }

  /**
   * Construit une URL avec le code pays
   */
  buildUrl(path: string): string {
    const countryCode = this.getCountryCode();
    if (countryCode) {
      return `/${countryCode}${path.startsWith('/') ? path : `/${path}`}`;
    }
    return path.startsWith('/') ? path : `/${path}`;
  }

  /**
   * Construit un tableau de segments pour router.navigate
   */
  buildRouteSegments(path: string): string[] {
    const countryCode = this.getCountryCode();
    const cleanPath = path.startsWith('/') ? path.substring(1) : path;
    if (countryCode) {
      return [countryCode, ...cleanPath.split('/')];
    }
    return cleanPath.split('/');
  }

  /**
   * Construit une URL pour les routes avec paramètres
   */
  buildRouteWithParams(
    basePath: string,
    ...params: (string | number)[]
  ): string[] {
    const countryCode = this.getCountryCode();
    const cleanPath = basePath.startsWith('/')
      ? basePath.substring(1)
      : basePath;
    if (countryCode) {
      return [
        countryCode,
        ...cleanPath.split('/'),
        ...params.map((p) => p.toString()),
      ];
    }
    return [
      ...cleanPath.split('/'),
      ...params.map((p) => p.toString()),
    ];
  }
}
